import type { AuthenticationModesPayload } from '@Application/Security/Sso/Actions/authenticationModesResolved';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * Carries its own scope (`email`) so a consumer can tell "these modes belong to the address currently
 * on screen" from "these modes belong to another one" without a companion field in the store.
 */
class AuthenticationModesView {
	readonly passwordEnabled: boolean;
	readonly ssoEnabled: boolean;
	readonly email: string;

	constructor(payload: AuthenticationModesPayload, email: string) {
		this.passwordEnabled = payload.passwordEnabled;
		this.ssoEnabled = payload.ssoEnabled;
		this.email = email;

		Object.freeze(this);
	}
}

export default AuthenticationModesView;
